/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plannamepro2Inputs */

const en_plannamepro2 = /** @type {(inputs: Plannamepro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const de_plannamepro2 = /** @type {(inputs: Plannamepro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Plannamepro2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plannamepro2 = /** @type {((inputs?: Plannamepro2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plannamepro2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plannamepro2(inputs)
	return de_plannamepro2(inputs)
});
export { plannamepro2 as "planNamePro" }